/**
 * H-425: localStorage keys that hold user-entered data but are NOT uid-scoped.
 * Every key (or key prefix) listed here must be cleared in AuthContext.logout()
 * so the next account signing in on the same device cannot see the previous
 * user's drafts. The event wizard draft key lives in
 * `features/create-event/context/eventDraftConstants.ts` (STORAGE_KEY) and is
 * cleared there too.
 */

/** Per-event preference drafts written by PreferencesForm: `prefs-draft:<eventId>` */
export const PREFS_DRAFT_KEY_PREFIX = 'prefs-draft:';
